import { Logo } from "./Logo";
import { scrollToSection } from "@/lib/scroll";

const COLS = [
  {
    title: "Company",
    links: [
      { label: "Services", href: "#services" },
      { label: "Pricing", href: "#pricing" },
      { label: "How It Works", href: "#how-it-works" },
      { label: "FAQ", href: "#faq" },
    ],
  },
  {
    title: "Get Started",
    links: [
      { label: "Book a Consultation", href: "#contact" },
      { label: "Calculate Savings", href: "#savings" },
      { label: "Request Pricing", href: "#pricing" },
    ],
  },
];

export const Footer = () => (
  <footer className="bg-[#0A261E] pt-16 pb-8" data-testid="site-footer">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="grid gap-12 md:grid-cols-4">
        <div className="md:col-span-2">
          <Logo dark />
          <p className="mt-5 max-w-sm text-sm leading-relaxed text-[#A3B8B0]">
            US-based virtual medical assistant services for practices of every size. HIPAA-trained,
            EHR-certified, and onboarded in 48 hours — at a fraction of in-house cost.
          </p>
        </div>
        {COLS.map((col) => (
          <div key={col.title}>
            <p className="font-mono text-xs uppercase tracking-[0.2em] text-[#EAB308]">{col.title}</p>
            <ul className="mt-4 space-y-2.5">
              {col.links.map((l) => (
                <li key={l.label}>
                  <button
                    onClick={() => scrollToSection(l.href)}
                    className="text-sm text-[#A3B8B0] transition-colors hover:text-[#F5F7F6]"
                    data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                  >
                    {l.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
      <div className="mt-14 flex flex-wrap items-center justify-between gap-4 border-t border-white/10 pt-6">
        <p className="font-mono text-xs text-[#A3B8B0]">
          © {new Date().getFullYear()} Verma Med Associates. All rights reserved.
        </p>
        <div className="flex items-center gap-5">
          <p className="font-mono text-xs text-[#A3B8B0]/60">HIPAA-Compliant · US-Based · 48-Hour Onboarding</p>
          <a href="/studio" data-testid="footer-studio-link" className="font-mono text-xs text-[#A3B8B0]/60 transition-colors hover:text-[#EAB308]">
            Owner Studio
          </a>
        </div>
      </div>
    </div>
  </footer>
);
